import { useMutation, useQuery, useQueryClient } from 'react-query';
import { createParameter, deleteParameter, fetchParameters, updateParameter, } from '@/features/parameter/services/parameterService';
const useParameters = (page = 1, filters = {}, all = false, limit = 10) => {
    const queryClient = useQueryClient();
    const { data, error, isLoading, refetch, } = useQuery(['parameters', { page, filters, all, limit }], () => fetchParameters(page, filters, all, limit), {
        keepPreviousData: true,
        staleTime: 5 * 60 * 1000,
    });
    const createMutation = useMutation((parameter) => createParameter(parameter), {
        onSuccess: () => {
            queryClient.invalidateQueries('parameters');
        },
    });
    const updateMutation = useMutation((payload) => updateParameter(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('parameters');
        },
    });
    const deleteMutation = useMutation((id) => deleteParameter(id), {
        onSuccess: () => {
            queryClient.invalidateQueries('parameters');
        },
    });
    return {
        parameters: data?.parametres ?? [],
        meta: data?.meta ?? null,
        loading: isLoading,
        error: error?.message ?? null,
        handleCreateParameter: createMutation.mutateAsync,
        handleUpdateParameter: updateMutation.mutateAsync,
        handleDeleteParameter: deleteMutation.mutateAsync,
        refetchParameters: refetch,
    };
};
export default useParameters;
